import aframe from 'aframe'

aframe.registerComponent('fixed', {
    schema: {
        enabled: { 
            type: "boolean", 
            default: true
        },

        fixY: {
            type: "boolean",
            default: true
        },

        fixX: {
            type: "boolean",
            default: true
        },

        offsetX: {
            type: "number",
            default: 0.0,
        },

        offsetY: {
            type: "number",
            default: 0.0,
        },
    },

    init: function() {
        this.onCameraChangeBinded = this.onCameraChange.bind(this)
        this.camera = document.getElementById('camera')

        let rotation = this.el.getAttribute('rotation')
        let angles = this.camera.getAttribute("rotation")

        if (this.data.enabled) {
            this.el.setAttribute('rotation', {
                x: (this.data.fixX) ? angles.x : rotation.x,
                y: (this.data.fixY) ? angles.y : rotation.y,
            })
        }

        this.camera.addEventListener('componentchanged', this.onCameraChangeBinded);
    },

    remove: function() {
        this.camera.removeEventListener('componentchanged', this.onCameraChangeBinded);
    },

    onCameraChange: function(e) {
        // console.log(this);

        if (e.detail.name !== 'rotation' || !this.data.enabled) {
            return
        }

        let rotation = this.el.getAttribute('rotation')

        let cameraAngleY = e.detail.newData.y + this.data.offsetY
        let cameraAngleX = e.detail.newData.x + this.data.offsetX

        this.el.setAttribute('rotation', {
            x: (this.data.fixX) ? cameraAngleX : rotation.x,
            y: (this.data.fixY) ? cameraAngleY : rotation.y,
        })

    }

});



// WEBPACK FOOTER //
// ./src/components-aframe/fixed.js